const favorite = {
    toggle: function (nurseryId, message = "キープが更新されました") {
        var paramList = new FormData();
        paramList.append("nurseryId", nurseryId);

        post.postAjaxData(
            "/parent/ajaxFavorite/toggle",
            paramList,
            message,
            favorite.favoriteDone,
            favorite.favoriteError
        );
    },
    // お気に入りが完了した
    favoriteDone: function (result, paramList) {
        if (result["status"] === 1) {
            // MST_ONのときは
            $('[data-nursery_id="' + paramList.get("nurseryId") + '"]').addClass("active");
        } else {
            $('[data-nursery_id="' + paramList.get("nurseryId") + '"]').removeClass("active");
        }
    },
    favoriteError: function (result, paramList) {
        if (result["status"] === 401) {
            // ログインできていないとき
            modalWindow.showModal("#js-modal-regist-guide");
        }
    }
};

window.favorite = favorite;
